<!-- Nothing waiting is nothing to say. The strip appears only when there is a
     decision to make, so it never becomes furniture people read past. -->
<div class="ap-strip" *ngIf="rows.length">
  <button type="button" class="br-btn br-btn--ghost ap-head" (click)="toggle()"
          [attr.aria-expanded]="open">
    <br-icon class="ap-head-icon">how_to_reg</br-icon>
    <span class="ap-head-text">
      <strong>{{ rows.length }}</strong>
      {{ rows.length === 1 ? 'action is' : 'actions are' }} waiting for your approval
    </span>
    <br-icon class="ap-chevron">{{ open ? 'expand_less' : 'expand_more' }}</br-icon>
  </button>

  <div class="ap-list" *ngIf="open">
    <div class="ap-row" *ngFor="let row of rows">
      <div class="ap-row-head">
        <button type="button" class="br-btn br-btn--link br-btn--sm ap-row-open" (click)="expand(row)">
          {{ row.summary || row.requestType }}
        </button>
        <span class="br-badge br-badge--neutral ap-risk"
              [class.ap-risk-high]="row.riskLevel === 'L1' || row.riskLevel === 'L2'">
          {{ row.riskLevel }}
        </span>
        <span class="ap-when">{{ row.createdAt | date:'MMM d' }}</span>
      </div>
      <div class="ap-row-meta">
        <span>{{ row.requestType }}</span>
        <span *ngIf="row.objectType && row.objectId">{{ row.objectType }} #{{ row.objectId }}</span>
        <span>raised by {{ row.requestedByActorType }}</span>
        <span class="ap-expiry" *ngIf="row.expiresAt">
          expires {{ row.expiresAt | date:'MMM d' }}</span>
      </div>

      <!-- Open one and you see exactly what would run. The payload is frozen
           with its hash, so showing a paraphrase here would be showing
           something other than what the token executes. -->
      <div class="ap-detail" *ngIf="expanded === row.id">
        <pre class="ap-payload">{{ payloadText(row) }}</pre>
        <mat-form-field appearance="outline" class="ap-reason" subscriptSizing="dynamic">
          <!-- Required, and said so: ApprovalLogic refuses a decision without
               one. Calling it optional here would be the screen inventing a
               rule the server does not have - in the direction that wastes a
               round trip to be told no. -->
          <mat-label>Reason (required)</mat-label>
          <input matInput [(ngModel)]="reason" />
        </mat-form-field>
        <div class="ap-actions">
          <button type="button" class="br-btn br-btn--primary br-btn--sm"
                  [disabled]="deciding === row.id || !reason.trim()"
                  (click)="decide(row, true)">
            {{ deciding === row.id ? 'Recording…' : 'Approve' }}
          </button>
          <button type="button" class="br-btn br-btn--outline-danger br-btn--sm"
                  [disabled]="deciding === row.id || !reason.trim()"
                  (click)="decide(row, false)">Reject</button>
          <button type="button" class="br-btn br-btn--link br-btn--sm" (click)="expand(row)">Cancel</button>
        </div>
        <div class="br-alert br-alert--danger ap-error" *ngIf="decideError">
          <br-icon>block</br-icon> {{ decideError }}
        </div>
      </div>
    </div>
  </div>
</div>
